export const resourceGroups = [
  {
    "id": "auto-glass-guides",
    "title": "Auto Glass & Windshield Help",
    "articles": [
      {
        "title": "Windshield Repair Vs Replacement: How To Choose",
        "href": "https://www.kosinsglass.com/windshield-repair-vs-replacement-how-to-choose",
        "description": "Compare chip repair, crack repair, and full replacement before scheduling service."
      },
      {
        "title": "How To Know Whether A Windshield Chip Can Be Repaired",
        "href": "https://www.kosinsglass.com/how-to-know-whether-a-windshield-chip-can-be-repaired",
        "description": "Learn which chips can usually be repaired and when replacement is the safer call."
      },
      {
        "title": "Signs Your Windshield Needs Immediate Replacement",
        "href": "https://www.kosinsglass.com/signs-your-windshield-needs-immediate-replacement",
        "description": "Know when windshield damage has moved beyond a simple repair."
      },
      {
        "title": "How Long Does Auto Glass Replacement Take?",
        "href": "https://www.kosinsglass.com/how-long-does-auto-glass-replacement-take",
        "description": "Plan around replacement time, safe drive-away time, and follow-up needs."
      },
      {
        "title": "Can I Drive After Windshield Replacement?",
        "href": "https://www.kosinsglass.com/can-i-drive-after-windshield-replacement",
        "description": "Understand the safety details that matter after new glass is installed."
      },
      {
        "title": "How Much Does Windshield Replacement Cost In Michigan?",
        "href": "https://www.kosinsglass.com/how-much-does-windshield-replacement-cost-in-michigan",
        "description": "See the factors that affect windshield replacement pricing."
      },
      {
        "title": "Best Way To Handle Insurance Claims For Auto Glass Damage",
        "href": "https://www.kosinsglass.com/best-way-to-handle-insurance-claims-for-auto-glass-damage",
        "description": "Review the basics before starting an auto glass insurance claim."
      },
      {
        "title": "How To File An Insurance Claim For Windshield Damage",
        "href": "https://www.kosinsglass.com/how-to-file-an-insurance-claim-for-windshield-damage",
        "description": "Prepare the details you may need before starting a windshield damage claim."
      },
      {
        "title": "When Insurance Will Pay For Windshield Replacement",
        "href": "https://www.kosinsglass.com/when-insurance-will-pay-for-windshield-replacement",
        "description": "Learn what may affect claim approval and out-of-pocket cost."
      },
      {
        "title": "How To Choose A Local Auto Glass Shop",
        "href": "https://www.kosinsglass.com/how-to-choose-a-local-auto-glass-shop",
        "description": "Compare safety, installation quality, insurance support, and calibration awareness."
      },
      {
        "title": "Best Auto Glass Safety Standards To Look For",
        "href": "https://www.kosinsglass.com/best-auto-glass-safety-standards-to-look-for",
        "description": "Understand safety, fit, materials, and installation quality basics."
      },
      {
        "title": "Is OEM Glass Better Than Aftermarket Replacement Glass?",
        "href": "https://www.kosinsglass.com/is-oem-glass-better-than-aftermarket-replacement-glass",
        "description": "Compare fit, quality, and practical considerations for replacement glass."
      },
      {
        "title": "What Causes Windshields To Crack In Michigan Weather?",
        "href": "https://www.kosinsglass.com/what-causes-windshields-to-crack-in-michigan-weather",
        "description": "Michigan weather, road debris, and temperature swings can all affect glass."
      },
      {
        "title": "Why Your Windshield Chip Keeps Spreading",
        "href": "https://www.kosinsglass.com/why-your-windshield-chip-keeps-spreading",
        "description": "Learn why small chips can become larger cracks."
      },
      {
        "title": "How To Prevent Rock Chips On Michigan Highways",
        "href": "https://www.kosinsglass.com/how-to-prevent-rock-chips-on-michigan-highways",
        "description": "Practical driving and maintenance habits that may reduce damage."
      }
    ]
  },
  {
    "id": "adas-safety-guides",
    "title": "ADAS Calibration & Vehicle Safety",
    "articles": [
      {
        "title": "How ADAS Calibration Works And Why It Matters",
        "href": "https://www.kosinsglass.com/how-adas-calibration-works-and-why-it-matters",
        "description": "Learn why camera and sensor alignment can matter after windshield work."
      },
      {
        "title": "Does My Car Need ADAS Calibration After Windshield Replacement?",
        "href": "https://www.kosinsglass.com/does-my-car-need-adas-calibration-after-windshield-replacement",
        "description": "Understand when calibration may be required for modern vehicles."
      },
      {
        "title": "How To Check If Your ADAS Is Properly Calibrated",
        "href": "https://www.kosinsglass.com/how-to-check-if-your-adas-is-properly-calibrated",
        "description": "Watch for warning signs after glass replacement or sensor service."
      },
      {
        "title": "Top Reasons Windshields Fail ADAS Calibration",
        "href": "https://www.kosinsglass.com/top-reasons-windshields-fail-adas-calibration",
        "description": "Review common causes of calibration trouble."
      },
      {
        "title": "Why Mobile Windshield Replacement Is Not Always Safe",
        "href": "https://www.kosinsglass.com/why-mobile-windshield-replacement-is-not-always-safe",
        "description": "Compare convenience with weather, workspace, and calibration considerations."
      },
      {
        "title": "Does Temperature Affect Windshield Damage?",
        "href": "https://www.kosinsglass.com/does-temperature-affect-windshield-damage",
        "description": "See why heat, cold, and defroster use can change a crack quickly."
      }
    ]
  },
  {
    "id": "shower-door-guides",
    "title": "Shower Doors & Bathroom Glass",
    "articles": [
      {
        "title": "How To Measure For A Custom Shower Door",
        "href": "https://www.kosinsglass.com/how-to-measure-for-a-custom-shower-door",
        "description": "Get familiar with the measurements that affect fit and layout."
      },
      {
        "title": "How Much Does Shower Door Installation Cost In Michigan?",
        "href": "https://www.kosinsglass.com/how-much-does-shower-door-installation-cost-in-michigan",
        "description": "Review the major pricing factors for custom shower glass."
      },
      {
        "title": "Frameless Vs Framed Shower Doors: Pros And Cons",
        "href": "https://www.kosinsglass.com/frameless-vs-framed-shower-doors-pros-and-cons",
        "description": "Compare style, maintenance, hardware, and project considerations."
      },
      {
        "title": "How To Maintain And Clean Glass Shower Doors",
        "href": "https://www.kosinsglass.com/how-to-maintain-and-clean-glass-shower-doors",
        "description": "Keep shower glass clearer with practical cleaning and care habits."
      }
    ]
  },
  {
    "id": "residential-glass-guides",
    "title": "Residential Window & Home Glass",
    "articles": [
      {
        "title": "When To Replace Fogged Or Failed Window Glass",
        "href": "https://www.kosinsglass.com/when-to-replace-fogged-or-failed-window-glass",
        "description": "Know what failed seals, condensation, and cloudy glass can mean."
      },
      {
        "title": "Understanding Double Pane Vs Triple Pane Glass",
        "href": "https://www.kosinsglass.com/understanding-double-pane-vs-triple-pane-glass",
        "description": "Compare insulated glass options and where each may make sense."
      },
      {
        "title": "Best Glass Types For Residential Windows In Michigan",
        "href": "https://www.kosinsglass.com/best-glass-types-for-residential-windows-in-michigan",
        "description": "Review glass choices for weather, comfort, and performance."
      },
      {
        "title": "Benefits Of Energy Efficient Residential Glass",
        "href": "https://www.kosinsglass.com/benefits-of-energy-efficient-residential-glass",
        "description": "Learn how glass selection can affect comfort and efficiency."
      },
      {
        "title": "How Custom Mirrors Are Measured And Installed",
        "href": "https://www.kosinsglass.com/how-custom-mirrors-are-measured-and-installed",
        "description": "See what goes into custom mirror sizing, edgework, and installation."
      },
      {
        "title": "Why Tempered Glass Matters For Safety",
        "href": "https://www.kosinsglass.com/why-tempered-glass-matters-for-safety",
        "description": "Understand where safety glass matters in homes and businesses."
      },
      {
        "title": "How To Choose A Reliable Glass Company In Michigan",
        "href": "https://www.kosinsglass.com/how-to-choose-a-reliable-glass-company-in-michigan",
        "description": "Review practical signs of a glass company that can handle the work correctly."
      }
    ]
  },
  {
    "id": "commercial-glass-guides",
    "title": "Commercial Glass",
    "articles": [
      {
        "title": "Commercial Storefront Glass Replacement Guide",
        "href": "https://www.kosinsglass.com/commercial-storefront-glass-replacement-guide",
        "description": "Plan around storefront glass damage, replacement, and business access."
      },
      {
        "title": "Best Glass Types For Office And Retail Storefronts",
        "href": "https://www.kosinsglass.com/best-glass-types-for-office-and-retail-storefronts",
        "description": "Compare glass options for visibility, durability, and safety."
      }
    ]
  },
  {
    "id": "howell-service-pages",
    "title": "Howell Service Center Pages",
    "articles": [
      {
        "title": "Auto Glass Repair In Howell",
        "href": "https://www.kosinsglass.com/auto-glass-repair-near-me-in-howell-mi",
        "description": "Local auto glass repair information for Kosins Glass in Howell, MI."
      },
      {
        "title": "Windshield Replacement In Howell",
        "href": "https://www.kosinsglass.com/windshield-replacement-near-me-in-howell-mi",
        "description": "Windshield replacement details for Howell-area drivers."
      },
      {
        "title": "Windshield Chip Repair In Howell",
        "href": "https://www.kosinsglass.com/windshield-chip-repair-near-me-in-howell-mi",
        "description": "Information about chip repair and when to act quickly."
      },
      {
        "title": "Car Door Glass Replacement In Howell",
        "href": "https://www.kosinsglass.com/car-door-glass-replacement-near-me-in-howell-mi",
        "description": "Side glass and door glass replacement information."
      },
      {
        "title": "Rear Window Replacement In Howell",
        "href": "https://www.kosinsglass.com/rear-window-replacement-near-me-in-howell-mi",
        "description": "Rear glass replacement details for local vehicle owners."
      },
      {
        "title": "ADAS Calibration In Howell",
        "href": "https://www.kosinsglass.com/adas-calibration-near-me-in-howell-mi",
        "description": "ADAS calibration information related to windshield replacement."
      },
      {
        "title": "Residential Window Glass In Howell",
        "href": "https://www.kosinsglass.com/residential-window-glass-replacement-near-me-in-howell-mi",
        "description": "Replacement glass information for residential windows."
      },
      {
        "title": "Foggy Double Pane Glass In Howell",
        "href": "https://www.kosinsglass.com/foggy-double-pane-glass-repair-near-me-in-howell-mi",
        "description": "Insulated glass and seal-failure information for local homeowners."
      },
      {
        "title": "Custom Glass Shower Enclosures In Howell",
        "href": "https://www.kosinsglass.com/custom-glass-shower-enclosure-near-me-in-howell-mi",
        "description": "Planning details for shower glass and enclosure projects."
      },
      {
        "title": "Shower Door & Bathroom Glass In Howell",
        "href": "https://www.kosinsglass.com/shower-door-bathroom-glass-repair-near-me-in-howell-mi",
        "description": "Repair and replacement information for bathroom glass."
      },
      {
        "title": "Mirror Replacement In Howell",
        "href": "https://www.kosinsglass.com/mirror-replacement-near-me-in-howell-mi",
        "description": "Custom mirror and replacement mirror information."
      },
      {
        "title": "Storm Window Repair In Howell",
        "href": "https://www.kosinsglass.com/storm-window-repair-near-me-in-howell-mi",
        "description": "Storm window glass repair and replacement details."
      },
      {
        "title": "Deck Railing Glass In Howell",
        "href": "https://www.kosinsglass.com/deck-railing-glass-replacement-near-me-in-howell-mi",
        "description": "Glass railing replacement information for homes and properties."
      },
      {
        "title": "Commercial Storefront Glass In Howell",
        "href": "https://www.kosinsglass.com/commercial-storefront-glass-repair-near-me-in-howell-mi",
        "description": "Storefront glass repair information for local businesses."
      }
    ]
  }
]
